<template>
  <div>
    <el-form class="el-form-m20" :inline="true" size="small" :model="condition">
      <el-form-item class="search-bar">
        <el-input :class="{'w-30vw':normal,'w-100per':!normal}" v-model="condition.title"
                  placeholder="请输入公司名称">
          <el-button class="btn-search" @click="search" icon="el-icon-search" slot="append"></el-button>
        </el-input>
      </el-form-item>

      <el-form-item v-if="normal">
        <el-button-group>
          <el-button v-if="perm.indexOf('employment:insert') > -1" type="primary"
                     icon="el-icon-circle-plus-outline"
                     @click="createRow">添加招聘信息
          </el-button>
          <el-button v-if="perm.indexOf('employment:set') > -1" type="primary" icon="el-icon-upload2"
                     @click="setOnline">一键上线
          </el-button>
          <el-button v-if="perm.indexOf('employment:set') > -1" type="warning" icon="el-icon-download"
                     @click="setOffline">一键下线
          </el-button>
          <el-button v-if="perm.indexOf('employment:delete') > -1" type="danger" icon="el-icon-delete"
                     @click="deleteSlt">批量删除
          </el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table
        ref="empTable"
        :data="list"
        tooltip-effect="dark"
        style="width: 100%"
        row-key="id"
        @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="45" :reserve-selection="true">
      </el-table-column>
      <el-table-column prop="id" label="编号" width="100">
      </el-table-column>
      <el-table-column prop="title" label="公司名" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="manager" label="联系人" width="100">
      </el-table-column>
      <el-table-column prop="mobile" label="联系电话" width="160">
      </el-table-column>
      <el-table-column prop="endTime" label="结束时间" width="160" :formatter="formatDate">
      </el-table-column>
      <el-table-column v-if="normal" label="操作">
        <template slot-scope="scope">
          <el-link v-if="perm.indexOf('employment:update') > -1"
                   type="primary"
                   icon="el-icon-edit"
                   @click="modifyRow(scope.$index, scope.row)">修改
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        :layout="normal ? 'sizes, prev, pager, next' : 'prev, pager, next'"
        :page-size="size"
        :total="total"
        :current-page.sync="index"
        @size-change="sizeChange"
        @current-change="currentChange">
    </el-pagination>
  </div>
</template>

<script>
import helper from "../common/CZHelper";

export default {
  name: "Employment",
  props: {
    normal: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL + "ma/employment/",
      dialogFormVisible: false,
      crtSelectionList: [],
      condition: {
        title: null
      },
      list: [],
      total: 0,
      perm: localStorage.getItem('perm').split(","),
      size: this.normal ? 10 : 6,
      index: 1
    }
  },
  created() {
    // this.getList();
  },
  beforeRouteEnter(to, from, next) {
    next(self => {
      if (from.meta.op === 'add') self.index = 1;
      self.getList()
    })
  },
  methods: {
    setOnline() {
      this.saveSetting(this.apiUrl + 'online');
    },
    setOffline() {
      this.saveSetting(this.apiUrl + 'offline');
    },
    saveSetting(url) {
      if (this.crtSelectionList.length <= 0) {
        this.$message.warning('请选择要设置的数据');
        return;
      }
      let ids = this.crtSelectionList.map(item => item.id).join(',');
      this.$axios.post(url, {'ids': ids}).then(({data}) => {
        if (data.code === 200) {
          this.$message.success('设置保存成功');
          this.cs();
          this.getList();
        } else {
          this.$message.error('设置保存失败');
        }
      });
    },
    formatDate(row, column, cellValue, index) {
      let d = new Date(cellValue);
      return d.getFullYear() + "-" + (d.getMonth() + 1)
          + "-" + d.getDate() + " " + d.getHours()
          + ":" + d.getMinutes() + ":" + d.getSeconds();
    },
    rowSelection(rows) {
      // 选择视频回调
      if (!rows.length) return;
      this.dlgSelectionList = rows;
    },
    sizeChange(val) {
      this.size = val;
      this.getList();
    },
    currentChange(val) {
      this.index = val;
      this.getList();
    },
    // 内部清除选择
    cs() {
      this.crtSelectionList = [];
      this.$refs['empTable'].clearSelection();
    },
    handleSelectionChange(val) {
      if (!this.normal) this.$emit("rowSelected", val);
      this.crtSelectionList = val;
    },
    deleteSlt() {
      this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false
      }).then(() => {
        if (this.crtSelectionList.length <= 0) return;
        let ids = [];
        this.crtSelectionList.map((v, i) => ids.push(v.id));
        // console.log(ids.join(","));
        this.$axios.post(
            this.apiUrl + "remove",
            {
              empIds: ids.join(",")
            }
        ).then(response => {
          if (response.data.code === 200) {
            this.getList();
            this.cs();
          }
        });
      }).catch(() => {
        //    点击取消按钮的操作，没有会报错
      });
    },
    createRow() {
      this.$router.push('employment/epmAddEdit');
    },
    modifyRow(rowIndex, row) {
      this.$router.push({
        name: 'epmAddEdit',
        params: {eid: row.id}
      });
    },
    search() {
      this.index = 1;
      this.getList();
    },
    getList() {
      let params = {
        index: this.index,
        size: this.size,
        emp: JSON.stringify(this.condition)
      };
      helper.getList(this.apiUrl + 'getEmpList', params, this);
    }
  }
}
</script>

<style scoped>
@import "../css/common.css";

.el-table th, .el-table td {
  padding: 5px 0;
}

.el-tag {
  margin: 0 5px 5px;
}

.el-link {
  margin: 0 5px;
}

.el-form-m20 {
  margin: 0 10px;
  /*text-align: right;*/
}

.school {
  color: #9f9f9f;
  width: 78px;
}

.filter {
  display: flex;
  color: #e79b37;
  padding: 10px 0 10px 25px;
  font-size: 0.9em;
  background: white;
  border-radius: 4px;
  margin-bottom: 20px;
}

.filter-item-active {
  color: #8b0000;
}

.filter-item {
  margin: 0 10px;
  cursor: pointer;
}

</style>